import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import { useParams } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask'

const LeadManagementContactModalContent = ({ handleClose, handleAdd, entityId }) => {
    const { leadManagementId } = useParams()
    const [request, loading] = useRequest()
    const { showToast } = useToast()
    const [entityData, setEntityData] = useState({
        leadManagementId: leadManagementId,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        role: null
    })

    useEffect(() => {
        getEntity()
    }, [entityId])

    const getEntity = () => {
        let id = entityData.id || entityId
        if (!id) return

        request(`/LeadManagement/GetLeadManagementContactById`, { params: { id: id } }).then((res) => {
            if (res.data.ok) {
                setEntityData(res.data.result)
            }
        })
    }

    const handleChange = (e, name) => {
        if (name) {
            setEntityData((prev) => ({ ...prev, [name]: e }))
        } else {
            setEntityData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
    }

    const handleSubmit = () => {
        if (!entityData.firstName || !entityData.lastName) {
            showToast('Lütfen ad ve soyad giriniz', 'error')
            return
        }

        request('/LeadManagement/UpsertLeadManagementContact', {
            method: 'PUT',
            data: entityData
        }).then((res) => {
            if (res.data.ok) {
                if (entityId) {
                    showToast('Kişi güncellendi', 'success')
                } else {
                    showToast('Kişi eklendi', 'success')
                }
                handleClose()
                handleAdd()
            }
        })
    }

    return (
        <>
            <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='text-bold'>Adı</label>
                            <input
                                value={entityData.firstName}
                                name='firstName'
                                onChange={handleChange}
                                className='default-input'
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='text-bold'>Soyadı</label>
                            <input
                                value={entityData.lastName}
                                name='lastName'
                                onChange={handleChange}
                                className='default-input'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Email Adresi</label>
                            <InputText
                                name='email'
                                type='email'
                                value={entityData.email}
                                onChange={handleChange}
                                className='default-input input-border'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Telefon Numarası</label>
                            <InputMask
                                mask='(999) 999-9999'
                                value={entityData.phone}
                                name='phone'
                                onChange={handleChange}
                                className='default-input input-border'
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Rolü</label>
                            <InputText
                                name='role'
                                value={entityData.role}
                                onChange={handleChange}
                                className='default-input input-border'
                            />
                        </div>
                    </div>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleSubmit}
                            className='btn-success w-100 justify-content-center'
                            title={'Kaydet'}
                            disabled={loading}
                        />
                    </div>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleClose}
                            className='btn-danger-outline w-100 justify-content-center'
                            title={'Vazgeç'}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

LeadManagementContactModalContent.propTypes = {
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
    entityId: PropTypes.number
}

export default LeadManagementContactModalContent
